import Vue from 'vue'
import App from './App.vue'
import axios from 'axios'

Vue.use(axios)

Vue.config.productionTip = false

new Vue({
  el: '#mortgage-calculator-wrapper',
  render(h) { return h(App, 
    { props:
      { name: this.$el.attributes.name.value }    
    })},
});